import IncomeReportBalances from "../income/IncomeReportBalances";

const ExpenseReportBalances = ({ cashInHand, amanat }) => (
  <IncomeReportBalances cashInHand={cashInHand} amanat={amanat} />
);

export default ExpenseReportBalances;
